import { withCommon } from '@/services/translation/commonTranslations';
import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
  en: {
    myProfile: {
      header: 'My Profile',
      editLabel: 'Edit Profile',
      editHeader: 'Edit My Profile'
    },
    myCalendar: {
      header: 'Calendar',
      tasks: (count: number) => `${count} ${count === 1 ? 'TASK' : 'TASKS'}`,
      viewRoster: 'View Roster',
      viewShiftDetails: 'View Shift Details',
      setAvailability: 'Set Availability',
      requestLeave: 'Request Leave',
      viewPendingRequest: 'View Pending Request',
      cancel: 'Cancel'
    },
    myAvailability: {
      header: 'Adjust Availability',
      availabilityLeaveType: 'Availability/Leave Type',
      availabilityStartTime: 'Availability Start Time',
      availabilityEndTime: 'Availability End Time',
      featureDisabled: 'Adjusting your availability is not enabled for this organisation.'
    },
    myLeave: {
      header: 'Request Leave',
      leaveType: 'Leave Type',
      startDate: 'Start Date',
      endDate: 'End Date',
      thisYear: 'this year',
      thisMonth: 'this month',
      remainingAfter: (n: number, label: string) =>
        `You will have ${n} ${n === 1 ? 'day' : 'days'} remaining for ${label} after this request.`,
      exceeded: (label: string, requested: number, remaining: number) =>
        `You don't have enough leave for ${label}: ${requested} ${requested === 1 ? 'day' : 'days'} requested, ${remaining} ${remaining === 1 ? 'day' : 'days'} remaining.`,
      overlapTitle: 'You already have a leave request or availability adjustment for these days:'
    },
    mySchedule: {
      header: 'Schedule and Leave',
      editLabel: 'Edit Availability Schedule',
      cardTitle: 'Preferred Schedule',
      featureDisabled: 'Editing your availability schedule is not enabled for this organisation.',
      notAvailable: 'Not available',
      dayLabels: {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday'
      },
      leave: {
        cardTitle: 'Leave',
        leaveBalances: 'Leave Balances',
        upcomingLeave: 'Upcoming Leave',
        noLeave: 'No leave scheduled',
        annualLeaveType: 'Leave type',
        monthlyLeaveType: 'Monthly leave type',
        taken: 'Taken',
        remaining: 'Remaining',
        addBooking: 'Add Booking'
      }
    },
    myRequests: {
      header: 'Requests'
    },
    viewRoster: {
      header: 'Roster'
    },
    viewShiftDetails: {
      header: 'Shift Details',
      breakLabel: 'Break Time',
      shiftStart: 'Shift Start',
      shiftEnd: 'Shift End',
      storeOpens: 'Store Opens',
      storeCloses: 'Store Closes'
    },
    role: 'Role',
    personalInformation: 'Personal Information',
    monthlySummary: {
      label: 'This Month',
      timeWorked: 'Time Worked',
      daysWorked: 'Days Worked',
      plannedAbsences: 'Planned Absences'
    }
  }
});

export default withCommon<typeof strings>(strings);
